import PropTypes from 'prop-types';
import ReactSelect, { components } from 'react-select';
import styled from 'styled-components';

import { ChevronDownIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';
import { styledComponentsTheme } from '@frontend/legacy-components/src/styledComponentsTheme';

/*
@TODO:
- Reset react-select theme
- Add icon dependency for close icon
- Fix mini labels
*/

const Input = (props) => {
  return <components.Input {...props} autoComplete="none" />;
};

const DropdownIndicator = () => <ChevronDownIcon size="28px" margin={-0.5} />;

const StyledReactSelect = styled(ReactSelect)`
  ${(props) => props.theme.font.size.E};
  font-family: ${(props) => props.theme.font.family.default};
  font-weight: ${(props) => props.theme.font.weight.default};
  cursor: pointer;
  width: 100%;

  .react-select__control {
    display: block;
    border-radius: 0.125rem;
    padding: 0;
    border-color: ${(props) => props.theme.color.separator.border} !important;
    min-height: 0;
  }

  .react-select__control--is-disabled {
    background-color: ${(props) => props.theme.color.interaction.plateLight};
    color: ${(props) => props.theme.color.feature.onInteraction};
    cursor: not-allowed;
    pointer-events: all !important;
  }

  .react-select__control--is-focused {
    box-shadow: 0 0 0px 3px ${(props) => props.theme.color.interaction.focus};
    border-color: ${(props) => props.theme.color.interaction.main} !important;
  }

  :not(.react-select--is-disabled) {
    .react-select__control {
      background: ${(props) => props.theme.color.page.surface};
      cursor: pointer;
    }

    :hover {
      .react-select__control {
        border-color: ${(props) =>
          props.theme.color.interaction.hover} !important;
      }
    }
  }

  .react-select__value-container {
    height: 1.5rem;
    box-sizing: content-box;
    padding: 0.25rem 0.5rem 0.25rem 0.625rem;

    div {
      margin: 0;
      padding: 0;
    }
  }

  .react-select__indicators {
    color: ${(props) => props.theme.color.feature.secondary};
    position: absolute;
    top: 0.4rem;
    right: 0.5rem;
    padding-right: 0;

    .react-select__indicator {
      color: ${(props) => props.theme.color.feature.placeholder};
      padding: 0 0.5rem;
      margin-top: -0.125rem;
      :hover {
        color: ${(props) => props.theme.color.feature.secondary};
      }
    }
  }

  .react-select__indicator-separator {
    background-color: inherit;
  }

  .react-select__placeholder {
    ${(props) => props.theme.font.size.E};
    color: ${(props) => props.theme.color.feature.placeholder};
  }

  .react-select__multi-value {
    background-color: ${(props) => props.theme.color.feature.plateLight};
    padding-left: 0.25rem !important;
    padding-right: 0.0625rem !important;
    margin-right: 0.25rem !important;
  }

  .react-select__multi-value__label {
    font-size: inherit;
  }

  .react-select__multi-value__remove {
    color: ${(props) => props.theme.color.feature.placeholder};
  }

  .react-select__multi-value__remove:hover {
    background-color: transparent;
    color: ${(props) => props.theme.color.feature.secondary};
  }

  .react-select__menu {
    border: 1px solid ${(props) => props.theme.color.separator.divider};
    box-shadow: ${(props) => props.theme.shadow.popover};
    border-radius: 0;
    padding: 0;
  }

  .react-select__menu-list {
    margin: -1;
    padding: 0;
  }

  .react-select__option {
    padding: 0.25rem 0.5rem;
  }

  .react-select__option--is-selected {
    background-color: ${(props) => props.theme.color.interaction.main};
  }

  input[id^='react-select-'] {
    opacity: 1 !important;
  }
`;

StyledReactSelect.defaultProps = {
  theme: styledComponentsTheme,
};

/**
 * @deprecated use Select from '@frontend/legacy-components' instead.
 */
export const OldSelect = ({
  className,
  disabled,
  menuPlacement = 'auto',
  onChange,
  options,
  value,
  defaultValue,
  ...props
}) => {
  const findOption = (value) =>
    value == null
      ? value
      : Array.isArray(value)
      ? options.filter((option) => value.includes(option.value))
      : options.find((option) => option.value === value);

  return (
    <StyledReactSelect
      blurInputOnSelect={false}
      className={className}
      classNamePrefix="react-select"
      components={{ Input, DropdownIndicator }}
      isDisabled={disabled}
      menuPlacement={menuPlacement}
      onChange={(option, actionType) => {
        if (Array.isArray(option)) {
          return onChange(option.map((op) => op.value));
        } else {
          onChange((option || {}).value, actionType);
        }
      }}
      options={options}
      value={findOption(value)}
      defaultValue={findOption(defaultValue)}
      {...props}
    />
  );
};

OldSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  menuPlacement: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
};
